module.exports = __webpack_public_path__ + "app-static/img/p_03.071c1122.jpg";